/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Search_ErrorInputs */

const cs_public_site_search_error = /** @type {(inputs: Public_Site_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídku se nepodařilo načíst.`)
};

const en_public_site_search_error = /** @type {(inputs: Public_Site_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load listings.`)
};

/**
* | output |
* | --- |
* | "Could not load listings." |
*
* @param {Public_Site_Search_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_search_error = /** @type {((inputs?: Public_Site_Search_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Search_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_search_error(inputs)
	return cs_public_site_search_error(inputs)
});